import {
  CircleCheck,
  ShieldAlert,
  Sparkles,
  Trash,
  Upload,
} from "lucide-react";
import { useState } from "react";

export default function VisaUploadSection() {
  const [error, setError] = useState("");
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (selected.size > 10 * 1024 * 1024) {
      setError("File Exceeds 10 MB limit");
      setFile(null);
      return;
    }

    setError("");
    setFile(selected);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // 👈 THIS stops browser from opening file
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const droppedFile = e.dataTransfer.files[0];
    if (!droppedFile) return;

    if (droppedFile.size > 10 * 1024 * 1024) {
      setError("File Exceeds 10 MB limit");
      setFile(null);
      return;
    }

    setError("");
    setFile(droppedFile);
  };

  return (
    <div className="mt-6 border rounded-xl p-6 bg-white">
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-bold text-lg font-inter text-[#572575]">
          Upload Your Visa
        </h3>
        <span
          className="
    inline-flex items-center gap-1
    px-3 py-2
    rounded-full
    text-white
    text-sm leading-[22px] font-semibold
    align-middle
    bg-gradient-to-r from-[#A65BF4] to-[#60358E]
    font-['Inter']
  "
        >
          <Sparkles size={14} />
          AI Auto Scan Enabled
        </span>
      </div>

      <p className="text-sm text-black font-inter my-7 flex items-center gap-2">
        <ShieldAlert color="#FAAE2D" size={18} />
        Automatically fill your travel history forms by scanning your visa
        document.
      </p>

      {!file && (
        <label
          className="border-2 border-dashed border-[#B38EC9] rounded-xl p-6 flex flex-col items-center cursor-pointer"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <input
            type="file"
            accept=".pdf,.png,.jpg,.jpeg"
            className="hidden"
            onChange={handleFileChange}
          />
          <img
            src="/uploadPassport.png"
            className="w-12 mx-auto mb-3 opacity-80"
          />
          <p className="text-[#572575] font-bold">Drag & Drop File Here</p>

          <p className="text-gray-500 text-sm mt-1">
            Supported formats: JPG, PNG, PDF (Max: 10MB)
          </p>
          <button className="mt-3 px-4 py-1 bg-[#572575] text-white text-sm font-inter rounded-md">
            Browse File
          </button>
        </label>
      )}

      {error && (
        <div className="mt-6">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div className="flex items-center gap-2 text-sm font-inter font-medium text-[#222222]">
              <span>Selected File</span>
              <span className="text-red-600 text-xs">
                <ShieldAlert size={17} />
              </span>
            </div>

            <label className="cursor-pointer text-[#572575] text-sm font-inter font-medium flex items-center gap-1">
              <Upload size={14} />
              Upload Again
              <input
                type="file"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
          </div>

          {/* Error Box */}
          <div className="flex items-center bg-[#FFF5F5]  rounded-lg overflow-hidden">
            {/* Left red bar */}
            <div className="w-1 self-stretch bg-[#D20000]" />

            <div className="px-4 py-3 text-sm font-inter">
              <span className="text-[#222222] font-medium">Passport.pdf</span>
              <span className="text-[#D20000]"> : {error}</span>
            </div>
          </div>
        </div>
      )}

      {file && !error && (
        <div className="mt-4  rounded-lg bg-white px-4 py-3">
          {/* Header */}
          <div className="flex justify-between items-center mb-3">
            <div className="flex items-center gap-2 text-sm font-medium text-[#222222] font-inter ">
              <span>Upload Successfully</span>
              <span className="text-green-600">
                <CircleCheck />
              </span>
            </div>

            <div className="flex gap-4 text-sm">
              <label className="cursor-pointer text-[#572575] text-sm font-inter font-medium flex items-center gap-1">
                <Upload size={14} /> Upload Again
                <input
                  type="file"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </label>

              <button
                onClick={() => setFile(null)}
                className="text-[#D20000] font-medium text-sm flex items-center gap-1"
              >
                <Trash size={14} /> Delete
              </button>
            </div>
          </div>

          {/* File Card */}
          <div className="flex justify-between items-center bg-[#FCFCFC] border border-[#EEEEEE] rounded-md px-3 py-3">
            <div className="flex items-center gap-3">
              {/* PDF Icon */}
              <div className="w-8 h-8 flex items-center justify-center bg-red-100 text-red-600 rounded">
                <img src="/pdf.png" alt="pdf" />
              </div>

              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-800">
                  {file.name}
                </span>

                <span className="text-xs text-blue-600 border border-blue-200 bg-blue-50 px-2 py-[2px] rounded">
                  Verified
                </span>
              </div>
            </div>

            <span className="text-xs text-gray-500">
              PDF Document{" "}
              <span className="text-black">
                {" "}
                •{(file.size / 1024).toFixed(2)} KB
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
